import React, { useEffect, useRef, useState } from 'react';

const TESTIMONIALS = [
{
  name: 'Amara Johnson',
  location: 'Atlanta, GA',
  tier: 'Growth',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11edb8861-1772475034213.png",
  alt: 'Amara Johnson, professional Black woman smiling confidently',
  quote: 'WIN transformed how I think about investing. Within 6 months of joining, I made my first angel investment in a women-led fintech startup. The community support is unmatched.',
  stars: 5
},
{
  name: 'Priya Sharma',
  location: 'New York, NY',
  tier: 'Pinnacle',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_13ab42514-1763298452113.png",
  alt: 'Priya Sharma, professional South Asian woman in business attire',
  quote: 'The AI assistant alone is worth the membership. It analyzed my entire portfolio and identified three rebalancing opportunities I had completely missed. My ROI is up 23% this year.',
  stars: 5
},
{
  name: 'Keisha Williams',
  location: 'Houston, TX',
  tier: 'Growth',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0007e95-1763295050768.png",
  alt: 'Keisha Williams, professional Black woman with warm smile',
  quote: 'I came in knowing nothing about investing. The WIN Academy courses are so well-structured — I went from Investing 101 to confidently managing a diversified portfolio in under a year.',
  stars: 5
}];


const TestimonialsSection = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setActive((a) => (a + 1) % TESTIMONIALS?.length), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-8 sm:py-14 bg-[#EEF1FA]" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className={`text-center mb-6 sm:mb-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <div className="inline-flex items-center gap-2 bg-[#D4A520]/15 border border-[#D4A520]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="text-[#D4A520] text-xs font-semibold tracking-widest uppercase">Member Stories</span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-6" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            What WIN Members Are Saying
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
          {TESTIMONIALS?.map((t, i) =>
          <div
            key={t?.name}
            onClick={() => setActive(i)}
            className={`bg-white rounded-2xl p-5 sm:p-8 shadow-md cursor-pointer ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${

            active === i ? 'ring-2 ring-[#D4A520] shadow-xl shadow-[#D4A520]/10' : ''}`
            }
            style={{
              transitionDelay: `${i * 100}ms`,
              transition: 'opacity 500ms ease, transform 300ms ease-out, box-shadow 300ms ease-out, border-left 300ms ease-out',
              transform: active === i ? 'translateY(-4px)' : 'translateY(0)',
              borderLeft: active === i ? '4px solid #D4A520' : '4px solid transparent'
            }}
            onMouseEnter={(e) => {
              if (active !== i) {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderLeft = '4px solid #D4A520';
              }
            }}
            onMouseLeave={(e) => {
              if (active !== i) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
                e.currentTarget.style.borderLeft = '4px solid transparent';
              }
            }}>
            
              <div className="flex items-center gap-3">
                <img
                src={t?.avatar}
                alt={t?.alt}
                className="w-12 h-12 rounded-full object-cover ring-2 ring-[#D4A520]/40 flex-shrink-0"
                onError={(e) => {e.currentTarget.style.display = 'none';}} />
              
                <div>
                  <div className="font-bold text-[#0B1F3B] text-sm">{t?.name}</div>
                  <div className="text-[#0B1F3B]/50 text-xs">{t?.location}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-[#D4A520]/15 text-[#D4A520] text-xs font-semibold px-2.5 py-1 rounded-full border border-[#D4A520]/30">
                    {t?.tier}
                  </span>
                </div>
              </div>

              <div className="flex gap-0.5 mt-4 mb-1">
                {Array.from({ length: t?.stars })?.map((_, si) =>
              <span key={si} className="text-[#D4A520] text-sm">★</span>
              )}
              </div>

              <p className="text-[#0B1F3B]/70 text-sm leading-relaxed italic mt-4" style={{ fontFamily: 'Georgia, serif' }}>
                "{t?.quote}"
              </p>
            </div>
          )}
        </div>

        {/* Dot indicators */}
        <div className="flex justify-center gap-2 mt-8">
          {TESTIMONIALS?.map((_, i) =>
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`rounded-full transition-all duration-300 ${
            active === i ? 'w-8 h-2.5 bg-[#D4A520]' : 'w-2.5 h-2.5 bg-[#D4A520]/30 hover:bg-[#D4A520]/60'}`
            } />

          )}
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;